<template>
  <div>
    <v-dialog v-model="bDialog" persistent>
      <div v-if="bEdu">
        <SecStudy_SKST v-if="$store.state.CustomInfo.SiteId == 'SKST'" :bSafe="true" @CloseEdu="bEdu=false; bSafety=true" @ResetEdu="CloseEducation()"/>
        <SecStudy_SKTC v-if="$store.state.CustomInfo.SiteId == 'SKTC'"  :bSafe="true" @CloseEdu="bEdu=false; bSafety=true" @ResetEdu="CloseEducation()"/>
        <SecStudy_SKMP v-if="$store.state.CustomInfo.SiteId == 'SKMP'"  :bSafe="true" @CloseEdu="bEdu=false; bSafety=true" @ResetEdu="CloseEducation()"/>
        <SecStudy_SKMJ v-if="$store.state.CustomInfo.SiteId == 'SKMJ'"  :bSafe="true" @CloseEdu="bEdu=false; bSafety=true" @ResetEdu="CloseEducation()"/>
        <SecStudy_SKMG14 v-if="$store.state.CustomInfo.SiteId == 'SKMG14'"  :bSafe="true" @CloseEdu="bEdu=false; bSafety=true" @ResetEdu="CloseEducation()"/>
        <SecStudy_SKMA v-if="$store.state.CustomInfo.SiteId == 'SKMA'"  :bSafe="true" @CloseEdu="bEdu=false; bSafety=true" @ResetEdu="CloseEducation()"/>
      </div>

      <div v-if="bSafety">
        <SecSafety_SKST v-if="$store.state.CustomInfo.SiteId == 'SKST'" @CloseSafety="onCloseSafety" @CloseEdu="bDialog = false; bSafety = false;"/>
        <SecSafety_SKTC v-if="$store.state.CustomInfo.SiteId == 'SKTC'" @CloseSafety="onCloseSafety" @CloseEdu="bDialog = false; bSafety = false;"/>
        <SecSafety_SKMP v-if="$store.state.CustomInfo.SiteId == 'SKMP'" @CloseSafety="onCloseSafety" @CloseEdu="bDialog = false; bSafety = false;"/>
        <SecSafety_SKMJ v-if="$store.state.CustomInfo.SiteId == 'SKMJ'" @CloseSafety="onCloseSafety" @CloseEdu="bDialog = false; bSafety = false;"/>
        <SecSafety_SKMG14 v-if="$store.state.CustomInfo.SiteId == 'SKMG14'" @CloseSafety="onCloseSafety" @CloseEdu="bDialog = false; bSafety = false;"/>
        <SecSafety_SKMA v-if="$store.state.CustomInfo.SiteId == 'SKMA'" @CloseSafety="onCloseSafety" @CloseEdu="bDialog = false; bSafety = false;"/>
      </div>
     
      <v-card v-if="bTest" >        
        <v-stepper v-model="e1">
          <v-stepper-header>
            <template v-for="n in steps">
              <v-stepper-step :key="`${n}-step`" :complete="e1 > n" :step="n" editable :color="zRandomQues[n-1].cSelOK != ''?'primary':'error'">문제{{ n }}</v-stepper-step>
              <v-divider v-if="n !== steps" :key="n"></v-divider>
            </template>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content v-for="(Question, n) in zRandomQues" :key="`${n + 1}-content`" :step="n + 1" class="content-center">
              <v-card flat>
                <v-card-text class="d-flex justify-center">
                  <v-card flat>
                    <div class="grey--text text--darken-1 d-flex" style="font-size:23px; font-weight: 600;">
                      {{Question.id}}.
                      <div class="ml-1">{{Question.cQuesData}}</div>
                    </div>
                    <!-- SKTC 지시표시 관련 이미지와 함께(보안경착용, 안전모착용, 방독면착용, 마스크착용) -->
                    <div class="ml-1 mt-5" v-if="Question.img && Array.isArray(Question.img)" style="display: flex; flex-direction: row; gap: 10px;">
                      <div v-for="(imageItem, index) in Question.img" :key="index" style="text-align: center;">
                        <!-- 이미지 표시 -->
                        <v-img :src="imageItem.img" alt="Question Image" width="150" height="170" />
                        
                        <!-- 이미지에 대응하는 텍스트 표시 -->
                        <div class="mt-2">{{ imageItem.text }}</div>
                      </div>
                    </div>
                    <v-radio-group v-model="Question.cSelOK">
                      <v-radio value="1">
                        <template v-slot:label>
                          <div class="d-flex">
                            1)<div class="ml-1">{{Question.cAnswer1}}</div>
                          </div>
                        </template>
                      </v-radio>
                      <v-radio value="2">
                        <template v-slot:label>
                          <div class="d-flex">
                            2)<div class="ml-1">{{Question.cAnswer2}}</div>
                          </div>
                        </template>
                      </v-radio>
                      <v-radio v-if="Question.cAnswer3 != null && Question.cAnswer3 != undefined" value="3">
                        <template v-slot:label>
                          <div class="d-flex">
                            3)<div class="ml-1">{{Question.cAnswer3}}</div>
                          </div>
                        </template>
                      </v-radio>
                      <v-radio v-if="Question.cAnswer4 != null && Question.cAnswer4 != undefined" value="4">
                        <template v-slot:label>
                          <div class="d-flex">
                            4)<div class="ml-1">{{Question.cAnswer4}}</div>
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-card>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-text align="right" class="pa-0 pt-4">
                  <v-spacer></v-spacer>
                  <v-btn v-if="n != 0" @click="PreviousStep(n + 1)" text width="90px" class="mr-2"><v-icon class="mr-2">mdi-chevron-left</v-icon>이전</v-btn>
                  <v-btn v-if="n != 9" @click="NextStep((n + 1),Question.cSelOK)" dark width="90px" class="ml-2"><v-icon class="mr-2">mdi-chevron-right</v-icon>다음</v-btn>
                  <v-btn v-if="n == 9" @click="Submit(Question.cSelOK)" dark width="90px" class="ml-2"><v-icon class="mr-2">mdi-clipboard-text-play</v-icon>제출</v-btn>
                </v-card-text>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>

      

      <!-- 보안 서약서 -->
      <div v-if="bPledge">
        <SecPledge :oCustomInfo="CustomInfo" @ClosePledge="bPledge=false; SetQuestionRes(CustomInfo.CustomId)" />
      </div>

      <CheckScore ref="CheckScoreRef" @AgainEdu="AgainEdu"/>
    </v-dialog>
  </div>
</template>


<script>
// import BasicInfo from "@/BasicInfo.js";
import axios from "axios"
import EventBus from '@/eventBus.js';
import SHA256 from "sha256";
import SecStudy_SKST from "./SecStudy_SKST.vue";
import SecStudy_SKTC from "./SecStudy_SKTC.vue";
import SecStudy_SKMP from "./SecStudy_SKMP.vue";
import SecStudy_SKMJ from "./SecStudy_SKMJ.vue";
import SecStudy_SKMG14 from "./SecStudy_SKMG14.vue";
import SecStudy_SKMA from "./SecStudy_SKMA.vue";
import SecSafety_SKST from "./SecSafety_SKST.vue";
import SecSafety_SKTC from "./SecSafety_SKTC.vue";
import SecSafety_SKMP from "./SecSafety_SKMP.vue";
import SecSafety_SKMJ from "./SecSafety_SKMJ.vue";
import SecSafety_SKMG14 from "./SecSafety_SKMG14.vue";
import SecSafety_SKMA from "./SecSafety_SKMA.vue";

import CheckScore from "./CheckScore.vue";
import SecPledge from "./SecPledge.vue";

export default {
  components: {    
    SecStudy_SKST,
    SecStudy_SKTC,
    SecStudy_SKMP,
    SecStudy_SKMJ,
    SecStudy_SKMG14,
    SecStudy_SKMA,
    SecSafety_SKST,
    SecSafety_SKTC,
    SecSafety_SKMP,
    SecSafety_SKMJ,
    SecSafety_SKMG14,
    SecSafety_SKMA,
    CheckScore,
    SecPledge,
  },
  
  props: {
  },
  data: () => ({
    bDialog: false,
    iCnt: 1,
    bEdu: false,
    bTest: false,
    bSafety: false,
    bPledge: false,
    zQuestions: [],
    zRandomQues: [],
    iCutScore: 100,
    iGetScore: 0,
    CustomInfo: null,
    cPassword: "",
    bShowNotiMsg: false,
    cPledge4: "N",
    cPledge5: "N",
    cPledge6: "N",
    e1: 1,
    steps: 10,
  }),

  watch: {
    steps (val) {
      if (this.e1 > val) {
        this.e1 = val
      }
    },

  },
  
  computed: {
  },
  
  created() {
    
  },

  mounted () {    
  },

  methods: {
    onCloseSafety() {      
      this.bSafety=false; 
      this.bTest=true;
    },
    Open(Data, ShowNotiMsg, Password) {
      this.GetQuestion();
      this.bDialog = true;
      this.bEdu = true;
      this.CustomInfo = Data;
      this.bShowNotiMsg = ShowNotiMsg;
      this.cPassword = Password || "";
    },

    CloseEducation() {  
      // console.log("취소취소")    
      this.bDialog = false;
      this.bEdu = false;

      if (this.bShowNotiMsg) {
        EventBus.$emit("onShowMsgBox","보안 교육을 취소하였습니다.", "교육 이수 후 테스트를 통과해야 로그인이 가능합니다.");
      }
    },

    NextStep (n,SelOk) {
      if (!this.CheckSolve(SelOk)){
        return
      }

      if (n === this.steps) {
        this.e1 = 1
      } else {
        this.e1 = n + 1
      }
    },

    CheckSolve(Answer){
      if (Answer == "") {
        EventBus.$emit("onShowMsgBox","문제의 답이 누락되었습니다", "답을 선택하여 주세요.");
        return false
      } else {
        return true
      }
    },

    PreviousStep (n){
      this.e1 = n-1
    },

    GetQuestion() {
      this.zQuestions = [];
      var posData = {
        SiteId : this.$store.state.CustomInfo.SiteId,
      };
      axios
        .post(process.env.VUE_APP_UIL_API + "GetQuestionInfo", posData, {
          headers: {
            //"Authorization": this.$store.state.UserInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd === "00") {
            this.zQuestions = res.data.Result;            
            let zQArray = [];
            let zFArray = [];
            for (var i = 0; i < res.data.Result.length; i++) {
              this.zQuestions[i].cSelOK = "";
              if (res.data.Result[i].cQuesId[0] == "Q") {
                zQArray.push(res.data.Result[i])
              } else {
                zFArray.push(res.data.Result[i])
              }
            }

            this.RandomQuestions(zQArray,zFArray)
            
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        // .catch(err => {
        //   EventBus.$emit("onShowMsg",true, "GetCustomInfo:"+err);
        // });
    },

    // 랜덤하게 문제 제출하기
    RandomQuestions(zQArray,zFArray) {
      if (zQArray.length == 0 || zFArray.length == 0) {        
        return
      }      

      let ztotal = [];

      // 이미지 경로 객체로 관리 (하나의 cQuesData에 여러 이미지)
      const imagePaths = {
        "다음 지시표시 중 설명이 잘못 된 것은?": [
          { img: require("@/assets/guide_dir_01.png"), text: "보안경착용" },
          { img: require("@/assets/guide_dir_05.png"), text: "안전모착용" },
          { img: require("@/assets/guide_dir_02.png"), text: "방독면착용" },
          { img: require("@/assets/guide_dir_06.png"), text: "마스크착용" }
        ],
      };

      for (let i = 0; i < 5; i++) {
        let a = zQArray.splice(Math.floor(Math.random() * zQArray.length), 1)[0];
        if (imagePaths[a.cQuesData]) {
          a.img = imagePaths[a.cQuesData]; // 이미지 배열 추가
        }
        ztotal.push(a);

        let b = zFArray.splice(Math.floor(Math.random() * zFArray.length), 1)[0];
        if (imagePaths[b.cQuesData]) {
          b.img = imagePaths[b.cQuesData]; // 이미지 배열 추가
        }
        ztotal.push(b);
      }     

      // ztotal.sort(() => Math.random() - 0.5)
      for (let i = 0 ; i < ztotal.length; i ++) {
        ztotal[i].id = i +1
      }
      this.zRandomQues = ztotal
    },

    


    // 문제 정답 제출하기
    Submit(SelOk) {
      if (!this.CheckSolve(SelOk)){
        return
      }

      this.iGetScore = 0;
      let zWrongQues = []

      for (var i = 0; i < this.zRandomQues.length; i++) {
        if (this.zRandomQues[i].cSelOK == "") {
          EventBus.$emit("onShowMsgBox", (i + 1) + " 번 문제의 답이 누락되었습니다", "답을 선택하여 주세요.");
          this.e1 = i + 1
          return  
        }
        if (this.zRandomQues[i].cSelOK == this.zRandomQues[i].cOK) {
          this.iGetScore += 10;
        } else {
          zWrongQues.push(this.zRandomQues[i])
        }
      }
      if (this.iGetScore < this.iCutScore) {
        this.$refs.CheckScoreRef.ShowDialog(zWrongQues,this.CustomInfo.CustomNm,this.iGetScore)
      } else {
        EventBus.$emit("onShowMsg",false, "테스트를 통과하였습니다.");
        this.bTest = false;
        this.bPledge = true;
      }
    },

    // 동의하고 나가기
    SetQuestionRes(CustomId) {
      if (!this.cPassword) {
        EventBus.$emit("onShowMsgBox", "인증 정보가 없습니다.", "다시 로그인한 후 교육을 진행하여 주세요.");
        return;
      }

      var posData = {
        SiteId : this.$store.state.CustomInfo.SiteId,
        cCustomId: CustomId,
        cCustomNickId: this.CustomInfo.CustomNickId,
        cPwd: SHA256(this.cPassword + "@" + this.CustomInfo.CustomNickId),
        cPledge4 : "Y",
        cPledge5 : "Y",
        cPledge6 : "Y",
      };
      
      axios
        .post(process.env.VUE_APP_UIL_API + "SetQuestionRes", posData, {
          headers: {
          }
        })
        .then(res => {
          if (res.data.ResultCd === "00") {
            localStorage.setItem("CustomInfo.Token", res.data.Data)
            this.CustomInfo.Token = res.data.Data
            this.$store.dispatch("login", this.CustomInfo)
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
        });
    },

    //재교육
    AgainEdu(){      
      for (var i = 0; i < this.zRandomQues.length; i++) {
        this.zRandomQues[i].cSelOK = ""
      }
      this.bTest = false;
      this.bEdu = true;
      this.e1 = 1;
    },

  },

}
</script>